import * as actionTypes from './actionTypes';
import {
    getSearchEndPoint
} from '../../util/utility';
import axios from 'axios';
import FileSaver from 'file-saver';
import * as applicationUrl from '../../config/actionUrl';

export const resetSearchStore = () => {
    return {
        type: actionTypes.RESET_SEARCH_STORE
    }
}

export const searchProductIdFail = (error) => {
    return {
        type: actionTypes.SEARCH_PRODUCT_ID_FAIL,
        error: error.debugMessage
    };
}

export const searchProductIdSuccess = (searchResults, searchRequestType) => {
    return {
        type: actionTypes.SEARCH_PRODUCT_ID_SUCCESS,
        searchResults: searchResults,
        searchRequestType: searchRequestType
    }
}

export const searchProductIdStart = () => {
    return {
        type: actionTypes.SEARCH_PRODUCT_ID_START
    }
}

export const searchProductId = (formData) => {
    return async dispatch => {
        dispatch(searchProductIdStart());
        axios.post(getSearchEndPoint(formData.searchRequestType), formData, {
            headers: {
                'Content-Type': 'application/json'
            },
            mode: "cors",
            withCredentials: true,
        }).then(res => {
            dispatch(searchProductIdSuccess(res.data, formData.searchRequestType));
        }).catch(err => {
            dispatch(searchProductIdFail(err.response.data.producterrorresponse));
        });
    }
}


export const downloadFileStart = () => {
    return {
        type: actionTypes.DOWNLOAD_FILE_START
    }
}

export const downloadFileSuccess = (result) => {
    return {
        type: actionTypes.DOWNLOAD_FILE_SUCCESS,
        result: result
    }
}

export const downloadFile = (formData) => {
    return dispatch => {
        dispatch(downloadFileStart());
        axios.post(applicationUrl.CSV_FILE_DOWNLOAD_END_POINT, formData, {
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: "blob",
            mode: "cors",
            withCredentials: true,
        }).then(res => {
            const disposition = res.request.getResponseHeader('Content-Disposition')
            var fileName = "";
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                fileName = matches[1].replace(/['"]/g, '');
            }
            let fileData = new Blob([res.data], {
                type: 'application/octet-stream'
            })
            FileSaver.saveAs(fileData, fileName);
            //Dispatch Success Action 
            dispatch(downloadFileSuccess("File Downloaded"));
        }).catch(err => {
            
            if(err.response.status === 400){
                dispatch(downloadFileFail({ debugMessage : "An error occurred while performing the requested operation"}));    
            }
            else if(err.response.status === 500) {
                
                dispatch(downloadFileFail(err.response.data.producterrorresponse));
            }
        });

    }
}

export const downloadFileFail = (error) => {
    return {
        type: actionTypes.DOWNLOAD_FILE_FAIL,
        error: error.debugMessage
    }
}
/*
export const sortParamsStart = () => {
    return {
        type: actionTypes.SORT_PARAMS_START
    }
}

export const sortParams = (result, sortColumn, sortOrder) => {

    return dispatch => {
        dispatch(sortParamsStart());
        try {
            result = result.sort((a, b) => {
                let startDate = new Date(a[sortColumn]);
                let endDate = new Date(b[sortColumn]);
                return sortOrder === "asc" ? startDate - endDate : endDate - startDate
            });
            dispatch(sortParamsSuccess(result));
        } catch (err) {
            dispatch(sortParamsFail(err));
        };
    }

}

export const sortParamsSuccess = (result) => {
    return {
        type: actionTypes.SORT_PARAMS_SUCCESS,
        result: result
    }
}

export const sortParamsFail = (error) => {
    return {
        type: actionTypes.SORT_PARAMS_FAIL,
        error: error
    }

}
*/